import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import MyDatePicker from "../../widgets/DatePicker";
import FixButton from "../../widgets/Button";
import addCorso from "../../services/addCorso";
import moment from "moment";
import Utils from "../../utils/utils";
import addCategorie from "../../services/addCategorieCorsi";
import addCategorieCorsi from "../../services/addCategorieCorsi";

export default class AddCategorie extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.section = this.props.section;
		if (this.section == undefined) {
			const pathname = props.location.pathname;
			this.section = pathname.substring(8, pathname.length);
		}

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.userslist = [];

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			nomeCategoria: "",
		};

		this.grid = 2;

		this.pageTitle = "Crea nuova categoria";
		this.startDateRef = React.createRef();
		this.endDateRef = React.createRef();

		this.state = {};
	}

	async componentDidMount() {
		this.setState({});
	}

	lockedSaveCorso = Utils.disallowConcurrency(this.save.bind(this));

	render() {
		function createData(username, name, surname) {
			return { username, name, surname };
		}

		var rows = [];
		this.userslist.length > 0 &&
			this.userslist.map((v, k) => {
				rows.push(createData(v.username, v.name, v.surname));
			});

		return (
			<>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />
					<TextInput
						name={"Nome"}
						value={this.state.nomeCategoria}
						onChange={text => {
							this.setState({ nomeCategoria: text });
						}}
					/>

					<br />

					<FixButton title={"Salva"} callback={this.state.isLoading ? () => {} : this.lockedSaveCorso} />
				</LoadingOverlay>
			</>
		);
	}

	async save() {
		this.setState({ isLoading: true });
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		let ret = await addCategorieCorsi(username, token, this.state.nomeCategoria);

		if (ret.result == "ok") {
			this.setState({ isLoading: false });
			window.location.href = "/#/app/categorie";
		} else {
			this.setState({ isLoading: false });
			alert("Si è verificato un errore inatteso durante la creazione del corso. Per favore riprova.");
		}
	}
}
